
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programowanie-firmware-ble",
      function () {
        return require("private-next-pages/programowanie-firmware-ble.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programowanie-firmware-ble"])
      });
    }
  